export default __webpack_public_path__ + "static/media/Pfizer-uk-logo-open-graph 1.785a2d66.svg";